export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(650)]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.down(650)]: {
      display: "flex",
    },
  },
  listitemRoot: {
    display: "flex",
    [theme.breakpoints.down(650)]: {
      flexDirection: "column",
    },
  },
});
